import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { ConditionalWrapper } from '@cian/conditional-component';
import { ArticleHeading2, ArticleHeading3 } from '@cian/ui-kit';

interface ITitleProps {
  children: React.ReactChild;
}

export const Title: React.FC<ITitleProps> = props => {
  const isDesktop = useIsDesktop();

  return (
    <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading2} ElseComponent={ArticleHeading3}>
      <span data-testid="estimation_chart_title">{props.children}</span>
    </ConditionalWrapper>
  );
};

Title.displayName = 'Title';
